var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.reportChart)?_c('pie-chart',{key:"report-chart",attrs:{"chart-data":_vm.reportChart,"tooltips-callback-cfg":_vm.tooltipsCallbackCfg}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }